/* unplugin-vue-components disabled */import script from "./CourseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseCard.vue?vue&type=script&setup=true&lang=js"

import "./CourseCard.vue?vue&type=style&index=0&id=7d50956b&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈工程-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d50956b"]])

export default __exports__